import { AxiosResponse } from "axios";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";

import { LOADING } from "../../store/actions";
import instance from "../../store/axios";
import ClosureRequest from "../../models/closure-request.model";
import { Status } from "../../models/enum";

class ClsodureRequestService {
  private dispatch = useDispatch();

  public async getClosureRequestListData(status: string[]): Promise<
    ClosureRequest[] | undefined
  > {
    this.dispatch({ type: LOADING, payload: true });
    let query: string = `?`;

    status.forEach((element: string, index: number) => {
      if (index === 0) {
        query += `status[${index}]=${element}`;
      } else {
        query += `&status[${index}]=${element}`;
      }
    });

    try {
      const response: AxiosResponse<ClosureRequest[]> = await instance.get(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/account/account-closure${query}`
      );
      return response.data;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", `/home/closure-requests`);

      return undefined;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }

  public async takeClosureRequestAction(
    requestId: number,
    status: Status,
    statusNotes: string,
    closureDate?: string
  ): Promise<boolean> {
    this.dispatch({ type: LOADING, payload: true });

    try {
      await instance.post(`/${process.env.REACT_APP_ENDPOINT_VERSION}/account/account-closure/${requestId}`, {
        status,
        statusNotes,
        ...(closureDate && { closureDate }),
      });
      toast.success("Customer data updated successfully");
      return true;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", `/home/closure-requests`);

      return false;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }
}

export default ClsodureRequestService;
